<template>
  <!-- name: '底部菜单栏组件' -->
  <div class="tabBarBox">
    <router-link
      :class="curPath.includes(item.path) ? 'actClass' : ''"
      :to="item.path"
      v-for="(item, index) in linkList"
      :key="index"
    >
      <img
        :src="
          `https://img.bbalt.cn/imgh5/menu_svg/tab_${item.icon}${
            curPath.includes(item.path) ? '_act' : ''
          }.svg`
        "
        alt=""
      />
      {{ item.name }}
    </router-link>
  </div>
</template>

<script>
export default {
  components: {},
  watch: {
    $route(next) {
      if (next.path !== "/other" && next.path !== "/userInfo") {
        this.setActTab();
      }
    },
  },
  data() {
    return {
      linkList: [
        { path: "/home", name: "首页", icon: "home" },
        { path: "/apply", name: "我要申领", icon: "apply" },
        { path: "/donate", name: "我要捐", icon: "donate" },
        { path: "/teamwork", name: "团队合作", icon: "teamwork" },
        { path: "/userCenter", name: "个人中心", icon: "userCenter" },
      ],
      curPath: "/home",
    };
  },
  methods: {
    setActTab() {
      this.curPath = this.$route.path;
    },
  },
  created() {
    this.setActTab();
  },
};
</script>

<style scoped lang="scss">
.tabBarBox {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
  background: #ffffff;
  box-shadow: 0px -1px 24px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  z-index: 999;
  a {
    text-align: center;
    display: flex;
    flex-flow: column;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #cccccc;
    text-shadow: 0px -1px 24px rgba(0, 0, 0, 0.1);
    font-size: 20px;
    img {
      width: 56px;
      height: 56px;
    }
    &:nth-child(3) {
      img {
        width: 106px;
        height: 106px;
        margin-top: -53px;
        border-radius: 50%;
      }
    }
    &.actClass {
      color: #333333;
    }
  }
}
</style>
